module.exports = __webpack_public_path__ + "static/black_pudding-34aee97ad906785b6d6558d1a107a0f1.jpeg";